import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { BUFFER_TYPE } from '@pixi/constants';
import { Buffer } from '../geometry/Buffer.mjs';
var UID = 0;
var UniformGroup = /*#__PURE__*/function () {
  function UniformGroup(uniforms, isStatic, isUbo) {
    _classCallCheck(this, UniformGroup);
    this.group = true;
    this.syncUniforms = {};
    this.dirtyId = 0;
    this.id = UID++;
    this.static = !!isStatic;
    this.ubo = !!isUbo;
    if (uniforms instanceof Buffer) {
      this.buffer = uniforms;
      this.buffer.type = BUFFER_TYPE.UNIFORM_BUFFER;
      this.autoManage = false;
      this.ubo = true;
    } else {
      this.uniforms = uniforms;
      if (this.ubo) {
        this.buffer = new Buffer(new Float32Array(1));
        this.buffer.type = BUFFER_TYPE.UNIFORM_BUFFER;
        this.autoManage = true;
      }
    }
  }
  _createClass(UniformGroup, [{
    key: "update",
    value: function update() {
      this.dirtyId++;
      if (!this.autoManage && this.buffer) {
        this.buffer.update();
      }
    }
  }, {
    key: "add",
    value: function add(name, uniforms, _static) {
      if (!this.ubo) {
        this.uniforms[name] = new UniformGroup(uniforms, _static);
      } else {
        throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
      }
    }
  }], [{
    key: "from",
    value: function from(uniforms, _static, _ubo) {
      return new UniformGroup(uniforms, _static, _ubo);
    }
  }, {
    key: "uboFrom",
    value: function uboFrom(uniforms, _static) {
      return new UniformGroup(uniforms, _static !== null && _static !== void 0 ? _static : true, true);
    }
  }]);
  return UniformGroup;
}();
export { UniformGroup };